import { HttpClientModule, HttpHeaders } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { Apollo, ApolloModule } from 'apollo-angular';
import { ApolloLink } from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';

// TODO: Handle
//import { setContext } from 'apollo-link-context';
import { environment } from 'environment';
import { AccessApi, ApplicationApi, AuditApi, CustomerAccountApi, CustomerCompanyApi, CustomerUserApi, LoginApi, NedermanCompanyApi, NedermanUserApi, SupplierApi, SyncApi, TenantApi } from './api';
import { AuditRest } from './audit-rest';
import { Rest } from './rest';
import { SyncRest } from './sync-rest';

const BACKEND_URL = environment.backendUrl + '/';

@NgModule({
  imports: [
    HttpClientModule,
    ApolloModule
  ],
  declarations: [
  ],
  providers: [
    Rest,
    SyncRest,
    AuditRest,
    LoginApi,
    ApplicationApi,
    AuditApi,
    AccessApi,
    CustomerAccountApi,
    CustomerCompanyApi,
    CustomerUserApi,
    NedermanCompanyApi,
    NedermanUserApi,
    SupplierApi,
    TenantApi,
    SyncApi
  ]
})
export class BackendModule {
  constructor(apollo: Apollo, httpLink: HttpLink) {
    const http = httpLink.create({ uri: BACKEND_URL + 'graphql' });
    const middleware = new ApolloLink((operation, forward) => {
      operation.setContext({
        headers: new HttpHeaders().set(
          'Authorization',
          `Bearer ${localStorage.getItem('token') || null}`,
        ),
      });
      return forward(operation);
    });

    const link = middleware.concat(http);
    // const defaultOptions = {
    //   watchQuery: {
    //     fetchPolicy: 'network-only',
    //     errorPolicy: 'ignore',
    //   },
    //   query: {
    //     fetchPolicy: 'network-only',
    //     errorPolicy: 'all',
    //   },
    // };

    console.log("Here")

    apollo.create({
      link: link,
      cache: new InMemoryCache(),
      // defaultOptions
    });
  }
}
